import React from 'react';

import FinalFeature from '@features/final';

function ElearningWpRemoteFinalPage() {
  return <FinalFeature />;
}

export default ElearningWpRemoteFinalPage;
